var map = {
	"./front_earth.png": "d84c",
	"./front_earth_normal.png": "aa68",
	"./front_fire.png": "8ccf",
	"./front_fire_normal.png": "b473",
	"./front_water.png": "915b",
	"./front_water_normal.png": "98bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2547";